/**
 * Configuration centrale de l'app — BPM Framework
 * Source de vérité pour sidebar, onglets, topbar (à terme pilotée par bpm.layout).
 * Alignée sur registerDefaultTabs.js pour migration progressive.
 */
export default {
  appName: 'BEAM Portfolio Manager',

  sidebar: {
    // requiredPermission (optionnel) : filtre BPM Phase 5 — item visible si permissions inclut cette valeur ou '*'
    items: [
      { id: 'accueil', label: 'Accueil', requiredPermission: 'view:accueil', children: ['accueil-vue-ensemble', 'accueil-performance', 'accueil-repartition'] },
      { id: 'portefeuille', label: 'Portefeuille', requiredPermission: 'view:portefeuille', children: ['portefeuille-synthese', 'portefeuille-detail', 'portefeuille-performance', 'portefeuille-volatilite', 'portefeuille-sentiment', 'portefeuille-ordres', 'portefeuille-valorisation'] },
      { id: 'compte', label: 'Compte', requiredPermission: 'view:compte', children: ['compte-performance', 'compte-synthese-tri', 'compte-apports-retraits', 'compte-investisseurs', 'compte-valorisations', 'compte-commentaires'] },
      { id: 'ai', label: 'Oliver', requiredPermission: 'view:ai', children: ['ai-chat'] },
      { id: 'analyse', label: 'Analyse', requiredPermission: 'view:analyse', children: ['analyse-analyse', 'analyse-feed-x', 'analyse-import', 'analyse-parametres'] },
      { id: 'stock-screener', label: 'Stock screener', requiredPermission: 'view:stock-screener', children: ['stock-screener-recherche', 'stock-screener-filtres', 'stock-screener-resultats'] },
      { id: 'macro', label: 'Macro', requiredPermission: 'view:macro', children: ['macro-indices', 'macro-matieres-premieres', 'macro-macro', 'macro-historique-120-ans'] },
      { id: 'parametres', label: 'Paramètres', requiredPermission: 'view:parametres', children: ['compte-settings', 'configuration', 'apparence', 'valeurs-par-defaut', 'api', 'import-export', 'utilisateurs', 'administration', 'configuration-admin', 'statuts', 'logs'] },
    ],
  },

  /** Liste plate des onglets (id, label, parent) pour BPM tabs par page */
  tabs: [
    { id: 'accueil-vue-ensemble', label: "Vue d'ensemble", parent: 'accueil' },
    { id: 'accueil-performance', label: 'Performance', parent: 'accueil' },
    { id: 'accueil-repartition', label: 'Répartition', parent: 'accueil' },
    { id: 'portefeuille-synthese', label: 'Synthèse', parent: 'portefeuille' },
    { id: 'portefeuille-detail', label: 'Portefeuille', parent: 'portefeuille' },
    { id: 'portefeuille-performance', label: 'Performance', parent: 'portefeuille' },
    { id: 'portefeuille-volatilite', label: 'Volatilité', parent: 'portefeuille' },
    { id: 'portefeuille-sentiment', label: 'Sentiment', parent: 'portefeuille' },
    { id: 'portefeuille-ordres', label: 'Ordres', parent: 'portefeuille' },
    { id: 'portefeuille-valorisation', label: 'Valorisation', parent: 'portefeuille' },
    { id: 'compte-performance', label: 'Performance', parent: 'compte' },
    { id: 'compte-synthese-tri', label: 'TRI', parent: 'compte' },
    { id: 'compte-apports-retraits', label: 'Apports/Retraits', parent: 'compte' },
    { id: 'compte-investisseurs', label: 'Investisseurs', parent: 'compte' },
    { id: 'compte-valorisations', label: 'Valorisations', parent: 'compte' },
    { id: 'compte-commentaires', label: 'Commentaires', parent: 'compte' },
    { id: 'stock-screener-recherche', label: 'Recherche', parent: 'stock-screener' },
    { id: 'stock-screener-filtres', label: 'Filtres', parent: 'stock-screener' },
    { id: 'stock-screener-resultats', label: 'Résultats', parent: 'stock-screener' },
    { id: 'analyse-analyse', label: 'Analyse', parent: 'analyse' },
    { id: 'analyse-feed-x', label: 'Feed', parent: 'analyse' },
    { id: 'analyse-import', label: 'Import', parent: 'analyse' },
    { id: 'analyse-export', label: 'Export', parent: 'analyse' },
    { id: 'analyse-parametres', label: 'Paramètres', parent: 'analyse' },
    { id: 'macro-indices', label: 'Indices', parent: 'macro' },
    { id: 'macro-matieres-premieres', label: 'Matières Premières', parent: 'macro' },
    { id: 'macro-macro', label: 'Macro', parent: 'macro' },
    { id: 'macro-historique-120-ans', label: 'Historique 120 ans', parent: 'macro' },
    { id: 'ai-chat', label: 'Chat Oliver', parent: 'ai' },
    { id: 'compte-settings', label: 'Profil', parent: 'parametres' },
    { id: 'configuration', label: 'Configuration', parent: 'parametres' },
    { id: 'apparence', label: 'Apparence', parent: 'parametres' },
    { id: 'valeurs-par-defaut', label: 'Valeurs par défaut', parent: 'parametres' },
    { id: 'api', label: 'API', parent: 'parametres' },
    { id: 'import-export', label: 'Import/Export', parent: 'parametres' },
    { id: 'utilisateurs', label: 'Utilisateurs', parent: 'parametres' },
    { id: 'administration', label: 'Administration', parent: 'parametres' },
    { id: 'configuration-admin', label: 'Paramètres généraux', parent: 'parametres' },
    { id: 'statuts', label: 'Statuts', parent: 'parametres' },
    { id: 'logs', label: 'Logs', parent: 'parametres' },
  ],

  topbar: {
    title: '', // Surchargé par page (ex. "Portefeuille", "Compte")
    actions: [], // Boutons optionnels (ex. "Historique Oliver", cloche notifications)
  },
};
